import React from 'react';
import { Box } from '@mui/material';
import fallbackImg from 'assets/images/fallback_img.jpg';
import artworkGif from 'assets/images/createAccLogin.mp4';

type PropsType = {
  children?: React.ReactNode;
};

/** An animation that is reused in multiple places of our application as background. */
const AnimatedVideoBackground = ({ children }: PropsType) => (
  <Box
    sx={{
      position: 'relative',
      width: '100%',
      height: '100%',
    }}
  >
    <video
      autoPlay
      muted
      loop
      poster={fallbackImg}
      style={{
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
    >
      <source src={artworkGif} type="video/mp4" />
    </video>
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default AnimatedVideoBackground;
